import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-patlogin',
  templateUrl: './patlogin.component.html',
  styleUrls: ['./patlogin.component.css']
})
export class PatloginComponent implements OnInit {
loginForm: FormGroup;
errorMessage:any;
navigationExtras:any;
  constructor(private Authservices:AuthService, private router:Router) { }

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      phone: new FormControl(null, [Validators.required]),
      otp: new FormControl(null, [Validators.required]),
    });
  }
  onClickLogin(){
    // console.log(this.loginForm.value.phone);
   var payload ={
      phoneNo:this.loginForm.value.phone,
    }
    
    this.Authservices.patientlogin(payload).subscribe((res:any)=>{
      console.log(res.status,"this is status");
      if(res.status <= 404 ){
        this.router.navigate(['patsignup']);
        // console.log("this is not register");
        
      }{
      this.router.navigate(['patotp']);
      // console.log("success");
      
    }console.error(res.status,"this is status");
    
    },(error) => {
      console.log(error);
      this.errorMessage = error;
      console.log(this.errorMessage.status,"this is status");
      if(this.errorMessage.status >= 404){
       
        this.navigationExtras= {
          state: {
          message : "Please SinUp First",
          }
        };
        this.router.navigate(['patsignup'],this.navigationExtras);
      }
    }
    );
    // if(this.errorMessage.status <= 404){
    //   this.router.navigate(['patotp'])
    // }
    
  }
}
